module.exports = __webpack_public_path__ + "static/media/agent-reg-image.f213b4df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/agent-reg-image.png
// module id = 274
// module chunks = 2